<script setup lang="ts">
import Icon from '../../../Icon/Icon.vue'
import StatusOverlay from '../StatusOverlay.vue'
</script>

<template>
  <StatusOverlay
    class="text-error-4 pointer-events-none animate-pulse text-center"
    data-testid="queue-error-status-overlay"
  >
    <Icon
      size="xl"
      icon="exclamation"
    />
    <div>Queue error - go to queue</div>
  </StatusOverlay>
</template>
